import { createI18n } from "vue-i18n";
import { lang, defaultLocale } from "./translate";
import Cookies from "js-cookie";
import { getCookieDomain } from "./utils/domain";

const LANGUAGE_COOKIE_NAME = "base-app_lang";
const cookieOptions = { domain: "." + getCookieDomain() };
const geoLocaleMap = {
    RU: "ru",
    BY: "ru",
    KZ: "ru",
    ES: "es",
    MX: "es",
    AR: "es",
    CL: "es",
    CO: "es",
    PE: "es",
    DE: "de",
    AT: "de",
    CH: "de",
    PL: "pl",
    CZ: "cs",
    SK: "cs",
    LU: "lb",
};

export const getSavedLocale = () => Cookies.get(LANGUAGE_COOKIE_NAME, cookieOptions);
export const isSupportedLocale = (locale) => Object.prototype.hasOwnProperty.call(lang, locale);
export const setLocaleCookie = (locale) => Cookies.set(LANGUAGE_COOKIE_NAME, locale, cookieOptions);

const messages = Object.assign(lang);
const savedLocale = getSavedLocale();
const i18n = createI18n({
    legacy: false,
    locale: savedLocale === undefined ? defaultLocale : savedLocale,
    fallbackLocale: "en",
    messages,
});

export async function resolveLocale() {
    const saved = getSavedLocale();
    if (saved !== undefined) {
        return saved;
    }

    if (typeof window === "undefined" || !import.meta.env.VITE_APP_API_AUTH) {
        return defaultLocale;
    }

    try {
        const response = await fetch(`${import.meta.env.VITE_APP_API_AUTH}/identity/geo`);
        const payload = await response.json();
        if (payload?.code === 200) {
            const country = payload?.data?.country;
            const matchedLocale = geoLocaleMap[country];
            if (matchedLocale && isSupportedLocale(matchedLocale)) {
                setLocaleCookie(matchedLocale);
                return matchedLocale;
            }
        }
    } catch (error) {
        console.error("Failed to resolve locale from geo", error);
    }

    setLocaleCookie(defaultLocale);
    return defaultLocale;
}

export default i18n;
